import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-info-banner",
    styleUrl: "info-banner.scss",
    shadow: true
})
export class InfoBanner {
    /** banner type: info is for info and partial failure, error for full failure */
    @Prop({ reflect: true }) readonly type: "info" | "error" = "info";
    /** icon that should be used in the banner */
    @Prop() readonly icon: string;

    render() {
        return (
            <Host
                class={{
                    [`ux-info-banner--type-${this.type}`]: true
                }}
            >
                <span
                    class={{
                        ["ux-info-banner__icon"]: true,
                        [`ux-info-banner__icon--type-${this.type}`]: true
                    }}
                >
                    <ux-icon name={this.icon} weight="medium" size-s={25}></ux-icon>
                </span>
                <div class="ux-info-banner__message ux-text-tiny ux-text-tiny--bold">
                    <slot />
                </div>
            </Host>
        );
    }
}
